export default "__VITE_ASSET__$SASLjrI__"